import { render, staticRenderFns } from "./AssociatedResources.vue?vue&type=template&id=5a9d7501&"
import script from "./AssociatedResources.vue?vue&type=script&lang=js&"
export * from "./AssociatedResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports